/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import { StyledAnchor }              from '../StyledAnchor';
import { Colours, Spacing, Borders } from '../../../styles/variables';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledButtonAnchor = StyledAnchor.extend`
  display: block;
  text-align: center;
  padding: ${Spacing.Tiny};
  color: ${Colours.White};
  background: ${props => props.theme.colour || Colours.Carnation};
  border-radius: ${Borders.Radius};
  border: 0;
  font-weight: 700;
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledButtonAnchor/index.js